import FiltersButton from "PFApp/components/filters/filters_button";
import React, { useState } from "react";

import css from "./filters_bar.module.scss";

export const FiltersBar = () => {
  const [filtersOpen, setFiltersOpen] = useState(false);

  return (
    <div className={css.filtersWrap}>
      <FiltersButton onClick={() => setFiltersOpen(!filtersOpen)} className={css.filterButton} />
    </div>
  );
};
